<template>
  <div>
    <HeadBanner
      v-if="$store.state.selected_menu"
      :itemData="$store.state.selected_menu"
    />
    <Breadcrumb />
    <MemberTabsContentInvestors
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.MemberTabsContent.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(
          this.$store.state.current_content,
          'secondary.MemberTabsContent.data'
        )
      "
      :itemConf="
        _.get(
          this.$store.state.current_content,
          'secondary.MemberTabsContent.conf'
        )
      "
      :tabsData="
        _.get(this.$store.state.indx, 'terms.investors_management_category')
      "
    />

    <intersect @enter="animate = true">
      <section class="container layout-outer flex-box">
        <div class="layout-left">
          <DownloadList
            v-if="
              _.get(
                this.$store.state.current_content,
                'secondary.DropdownList.conf.enabled'
              ) == 1
            "
            :itemData="
              _.get(this.$store.state.current_content, 'secondary.DropdownList.data.0.smarttabs')
            "
          />
        </div>
      </section>
    </intersect>

    <NewsAndMedia
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.NewsAndMedia.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.NewsAndMedia')
      "
    />

    <Partners
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.Partners.conf.enabled'
        ) == 1
      "
      :itemData="_.get(this.$store.state.current_content, 'secondary.Partners')"
    />
  </div>
</template>


<script>
import HeadBanner from "@/components/HeadBanner";
import MemberTabsContentInvestors from "@/components/MemberTabsContentInvestors";
import Breadcrumb from "@/components/Breadcrumb";
import NewsAndMedia from "@/components/NewsAndMedia";
import DownloadList from "@/components/DownloadList";
import Partners from "@/components/Partners";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    MemberTabsContentInvestors,
    NewsAndMedia,
    DownloadList,
    Partners,
  },
};
</script>
